export const ROLE_SLUG = {
  ADMINISTRATOR: 'administrator',
  MEMBER: 'member',
  PENDING_MEMBER: 'pending_member',
} as const;

type RoleList = readonly string[] | null | undefined;

function hasRole(roles: RoleList, role: string): boolean {
  return Boolean(roles?.includes(role));
}

export function isApprovedBoundary(roles: RoleList): boolean {
  return hasRole(roles, ROLE_SLUG.ADMINISTRATOR) || hasRole(roles, ROLE_SLUG.MEMBER);
}

export function canUseFavorites(roles: RoleList): boolean {
  return isApprovedBoundary(roles);
}

export function isPendingBoundary(roles: RoleList): boolean {
  return hasRole(roles, ROLE_SLUG.PENDING_MEMBER);
}
